import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const menuRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (isOpen && menuRef.current && buttonRef.current && !menuRef.current.contains(event.target as Node) && !buttonRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);
  const navLinks = [{
    path: '/',
    label: 'Inicio'
  }, {
    path: '/about',
    label: 'Nosotros'
  }, {
    path: '/products',
    label: 'Productos'
  }, {
    path: '/contact',
    label: 'Contacto'
  }];
  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, path: string) => {
    if (location.pathname === path) {
      e.preventDefault();
      setIsOpen(false);
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, 300);
    } else {
      if (isOpen) {
        setIsOpen(false);
      }
    }
  };
  const colors = {
    text: 'text-blue-600',
    hover: 'hover:text-blue-600',
    bg: 'bg-blue-600',
    hoverBg: 'hover:bg-blue-700'
  };
  const Path = (props: any) => <motion.path fill="transparent" strokeWidth="3" stroke={scrolled ? 'currentColor' : 'white'} strokeLinecap="round" {...props} />;
  const menuVariants = {
    closed: {
      opacity: 0,
      height: 0,
      transition: {
        duration: 0.3,
        ease: 'easeInOut'
      }
    },
    open: {
      opacity: 1,
      height: 'auto',
      transition: {
        duration: 0.3,
        ease: 'easeInOut'
      }
    }
  };
  return <motion.nav className={`w-full fixed top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/80 backdrop-blur-md border-b border-gray-200 shadow-sm' : 'bg-transparent'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <motion.div className="flex-shrink-0 flex items-center" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }}>
            <Link to="/" onClick={e => handleLinkClick(e, '/')} className={`text-xl font-bold transition-colors duration-300 flex items-center gap-2 ${scrolled ? colors.text : 'text-white'}`}>
              <img src={scrolled ? "/ipse-logo-dark.png" : "/ipse-logo-white.png"} alt="IPSE S.A." className="h-8" />
              IPSE S.A.
            </Link>
          </motion.div>
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link, index) => <motion.div key={link.path} initial={{
            opacity: 0,
            y: -10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} className="relative">
                <Link to={link.path} onClick={e => handleLinkClick(e, link.path)} className={`relative inline-block transition-colors duration-300 ${scrolled ? 'text-gray-700' : 'text-white'} ${colors.hover}`}>
                  <span className="relative z-10">{link.label}</span>
                  <motion.div className={`absolute bottom-0 left-0 h-0.5 ${colors.bg}`} initial={{
                width: 0
              }} whileHover={{
                width: '100%'
              }} transition={{
                duration: 0.3
              }} />
                </Link>
              </motion.div>)}
          </div>
          <div className="md:hidden flex items-center">
            <button ref={buttonRef} onClick={() => setIsOpen(!isOpen)} className="w-10 h-10 flex items-center justify-center focus:outline-none" aria-label="Toggle menu">
              <svg width="23" height="23" viewBox="0 0 23 23">
                <AnimatePresence mode="wait">
                  {isOpen ? <motion.g key="close" initial={{
                  opacity: 0,
                  rotate: 0
                }} animate={{
                  opacity: 1,
                  rotate: 180
                }} exit={{
                  opacity: 0,
                  rotate: 0
                }} transition={{
                  duration: 0.3
                }}>
                      <Path d="M 3 16.5 L 17 2.5" initial={{
                    opacity: 0,
                    pathLength: 0
                  }} animate={{
                    opacity: 1,
                    pathLength: 1
                  }} transition={{
                    duration: 0.3
                  }} />
                      <Path d="M 3 2.5 L 17 16.346" initial={{
                    opacity: 0,
                    pathLength: 0
                  }} animate={{
                    opacity: 1,
                    pathLength: 1
                  }} transition={{
                    duration: 0.3
                  }} />
                    </motion.g> : <motion.g key="menu" initial={{
                  opacity: 0
                }} animate={{
                  opacity: 1
                }} exit={{
                  opacity: 0
                }} transition={{
                  duration: 0.3
                }}>
                      <Path d="M 2 2.5 L 20 2.5" initial={{
                    opacity: 0,
                    pathLength: 0
                  }} animate={{
                    opacity: 1,
                    pathLength: 1
                  }} transition={{
                    duration: 0.3
                  }} />
                      <Path d="M 2 9.423 L 20 9.423" initial={{
                    opacity: 0,
                    pathLength: 0
                  }} animate={{
                    opacity: 1,
                    pathLength: 1
                  }} transition={{
                    duration: 0.3,
                    delay: 0.1
                  }} />
                      <Path d="M 2 16.346 L 20 16.346" initial={{
                    opacity: 0,
                    pathLength: 0
                  }} animate={{
                    opacity: 1,
                    pathLength: 1
                  }} transition={{
                    duration: 0.3,
                    delay: 0.2
                  }} />
                    </motion.g>}
                </AnimatePresence>
              </svg>
            </button>
          </div>
        </div>
      </div>
      <AnimatePresence>
        {isOpen && <motion.div ref={menuRef} className="md:hidden" initial="closed" animate="open" exit="closed" variants={menuVariants}>
            <motion.div className={`px-4 pt-2 pb-3 space-y-1 ${scrolled ? 'bg-white/05' : `${colors.bg}/90 backdrop-blur-md`}`}>
              {navLinks.map((link, index) => <motion.div key={link.path} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: index * 0.1
          }}>
                  <Link to={link.path} onClick={e => handleLinkClick(e, link.path)} className={`block px-3 py-2 rounded-md text-base font-medium ${scrolled ? 'text-gray-700 hover:text-blue-600 hover:bg-white/50' : 'text-white hover:bg-white/10'}`}>
                    {link.label}
                  </Link>
                </motion.div>)}
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </motion.nav>;
};